export default function CommentIcon() {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
<svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.996 0.558594C4.48713 0.558594 0.00409961 4.74187 0.00409961 9.88437C0.0100308 11.7466 0.60199 13.5598 1.69606 15.0668C1.44639 15.659 1.14198 16.2266 0.786798 16.7621L0.340494 17.4282C0.137932 17.7292 0.0211266 18.0797 0.0026061 18.442C-0.0159144 18.8043 0.0645487 19.1649 0.235365 19.4849C0.406181 19.805 0.660906 20.0725 0.972218 20.2588C1.28353 20.4451 1.63968 20.5431 2.00248 20.5424C3.86222 20.5453 5.67224 19.9419 7.1583 18.8238C8.08224 19.081 9.03693 19.211 9.996 19.2101C15.5049 19.2101 19.9879 15.0269 19.9879 9.88437C19.9879 4.74187 15.5049 0.558594 9.996 0.558594ZM9.996 17.2118C8.87152 17.2124 7.75791 16.9917 6.71866 16.5623C6.10337 17.189 5.36949 17.687 4.55979 18.0273C3.75009 18.3675 2.88076 18.5432 2.00248 18.544L2.44878 17.8779C3.09937 16.8904 3.61045 15.8178 3.96755 14.6905C2.71631 13.4024 2.0121 11.6801 2.00248 9.88437C2.00248 5.83765 5.58291 2.55697 9.996 2.55697C14.4091 2.55697 17.9895 5.83765 17.9895 9.88437C17.9895 13.9311 14.4091 17.2118 9.996 17.2118Z"
        fill="#131313"
      />
      <path
        d="M5.99919 10.8831C6.55103 10.8831 6.99838 10.4358 6.99838 9.88396C6.99838 9.33212 6.55103 8.88477 5.99919 8.88477C5.44735 8.88477 5 9.33212 5 9.88396C5 10.4358 5.44735 10.8831 5.99919 10.8831Z"
        fill="#131313"
      />
      <path
        d="M13.9924 10.8831C14.5442 10.8831 14.9915 10.4358 14.9915 9.88396C14.9915 9.33212 14.5442 8.88477 13.9924 8.88477C13.4405 8.88477 12.9932 9.33212 12.9932 9.88396C12.9932 10.4358 13.4405 10.8831 13.9924 10.8831Z"
        fill="#131313"
      />
      <path
        d="M9.99577 10.8831C10.5476 10.8831 10.995 10.4358 10.995 9.88396C10.995 9.33212 10.5476 8.88477 9.99577 8.88477C9.44393 8.88477 8.99658 9.33212 8.99658 9.88396C8.99658 10.4358 9.44393 10.8831 9.99577 10.8831Z"
        fill="#131313"
      />
    </svg>
  );
}
